import * as CookieTransformer from 'cookie';

const DEFAULT_VALUE = '{}';

export class Cookie {
  private _key: string;

  constructor({ key }: { key: string }) {
    this._key = key;
    this._ensureCookie();
  }

  private _serializeCookie(value: string = DEFAULT_VALUE) {
    const url = new URL(document.location.href);
    const domain = url.hostname.split('.').slice(-2).join('.');

    return CookieTransformer.serialize(this._key, value, {
      domain, // Ersetze dies mit deiner tatsächlichen Domain
      path: '/',
      sameSite: 'none', // Oder 'lax', aber nicht 'none' für __Host
      secure: true, // Wichtig für __Host
      maxAge: 1000 * 60 * 60 * 24 * 365,
    });
  }

  private _ensureCookie() {
    if (this.getCookie()) return;
    document.cookie = this._serializeCookie();
  }

  getCookie() {
    const cookies = CookieTransformer.parse(document.cookie);
    return cookies[this._key];
  }

  setValue(key: string, value: string) {
    const cookieValueObj = this._getCookieValueObject();
    cookieValueObj[key] = value;
    document.cookie = this._serializeCookie(JSON.stringify(cookieValueObj));
  }

  getValue(key: string): string | undefined;
  getValue(key: string, type: 'boolean'): boolean | undefined;
  getValue(key: string, type: 'json'): Record<string, any> | undefined;
  getValue(key: string, type?: 'boolean' | 'json') {
    const cookieValueObj = this._getCookieValueObject();
    const value = cookieValueObj[key];
    if (value === undefined) return value;

    switch (type) {
      case 'boolean':
        return value === 'true';
      case 'json':
        try {
          const valueObj = JSON.parse(value);
          return valueObj;
        } catch {
          return undefined;
        }
      default:
        return value;
    }
  }

  private _getCookieValueObject(): Record<string, string> {
    const cookieValue = this.getCookie() ?? DEFAULT_VALUE;
    return JSON.parse(cookieValue);
  }
}
